import React from 'react'
import PropTypes from 'prop-types'
import { Button, Container } from '@sainsburys-tech/fable'

import signInBadge from '../../assets/SignInConfirmBadge.gif'
import signOutBadge from '../../assets/SignOutConfirmBadge.png'

import LoadingOverlay from '../LoadingOverlay'
import Feedback from '../Feedback'
import { AppId } from '../../utils/constants'
import api from '../../utils/api'

class ConfirmationPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showFeedback: false,
      isLoading: true
    }
  }

  componentDidMount() {
    const {
      setHeader, setSignOutHeader, history, user
    } = this.props
    setHeader()
    setSignOutHeader(false)

    const isSignOut = history.location.state && history.location.state.signIn === false

    if (isSignOut) {
      api.showFeedback(AppId, user.username)
        .then((res) => {
          this.setState({ showFeedback: Boolean(res && res.show), isLoading: false })
        })
        .catch(() => {
          this.setState({ showFeedback: false, isLoading: false })
        })
    } else {
      this.setState({ isLoading: false })
    }
  }

  handleDone = (e) => {
    e.preventDefault()

    const { history } = this.props

    if (history.location.state && history.location.state.signIn) {
      history.push('/signout')
    } else if (history.location.state && history.location.state.signIn === false) {
      history.push('/signin')
    }
  }

  render() {
    const { showFeedback, isLoading } = this.state
    const { user, history } = this.props
    const isSignOut = history.location.state && history.location.state.signIn === false

    const isSignIn = history.location.state && history.location.state.signIn
    const badge = isSignOut ? signOutBadge : signInBadge
    const signInMode = isSignOut ? 'Out' : 'In'

    let details = null
    if (isSignIn) {
      details = (
        <>
          <div>{`Hi ${user.forename},`}</div>
          <div>have a good day</div>
        </>
      )
    } else if (isSignOut) {
      details = `See ya later ${user.forename}`
    }

    if (isLoading) {
      return <LoadingOverlay hasBackground text={`Signing ${signInMode}...`} />
    }

    return (
      <React.Fragment>
        {isSignOut
          && (
          <Feedback
            appId={AppId}
            email={user.username}
            headerText="How was Sign-In Book?"
            bodyText="We want to know how you found using Sign-In Book today, so we can learn from your feedback and improve the tools you use."
            showFeedback={showFeedback}
          />
          )
        }
        <div className="c-badge-background" />
        <Container as="div" className="dsib-confirmationPage u-no-scroll__vertical">
          <div className="c-badge-container">
            <img src={badge} alt="" className="c-badge-gif" aria-hidden="true" />
          </div>
          <div className="c-badge-details">{details}</div>
          <div className="c-badge-btn">
            <Button className="dsib-confirmationPage__done" variant="tertiary" onClick={this.handleDone}>Done</Button>
          </div>
        </Container>
      </React.Fragment>
    )
  }
}

ConfirmationPage.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setSignOutHeader: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  user: PropTypes.shape({
    forename: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
  }).isRequired,
}

export default ConfirmationPage
